module.exports = __webpack_public_path__ + "static/assets/adce0d9866f09d1d52ba792df6005fef.png";